import React, { useState, useRef, useEffect } from 'react';
import '../styles/chatTerminal.css';
import realTimeChatService from '../services/realTimeChatService';
import authService from '../services/loginService';

const ChatTerminal = () => {
    // Estado para almacenar todos los chats con sus mensajes
    const currentUser = authService.getCurrentUser();
    const [chatData, setChatData] = useState({
        1: {
            id: 1,
            name: "Consulta sobre registro de placa",
            time: "10:34 pm",
            unread: 2,
            messages: [
                {
                    id: 1,
                    text: "Buenas Tardes, en que puedo ayudar?",
                    sender: "agent",
                    timestamp: new Date()
                },
                {
                    id: 2,
                    text: "Buenas, es que se registró mal la placa",
                    sender: "customer",
                    timestamp: new Date()
                },
                {
                    id: 3,
                    text: "Ya le ayudo, mantenganse en linea por favor",
                    sender: "agent",
                    timestamp: new Date()
                }
            ]
        },
        2: {
            id: 2,
            name: "Problema con facturación",
            time: "12:34 pm",
            unread: 1,
            messages: [
                {
                    id: 1,
                    text: "Hola, tengo un problema con mi factura",
                    sender: "customer",
                    timestamp: new Date()
                },
                {
                    id: 2,
                    text: "Buenos días, con gusto le ayudo. ¿Podría decirme cuál es el inconveniente?",
                    sender: "agent",
                    timestamp: new Date()
                },
                {
                    id: 3,
                    text: "Me cobraron de más en el último mes",
                    sender: "customer",
                    timestamp: new Date()
                }
            ]
        },
        3: {
            id: 3,
            name: "Solicitud de información de servicios",
            time: "9:15 am",
            unread: 0,
            messages: [
                {
                    id: 1,
                    text: "Buenos días, me interesa conocer sus servicios",
                    sender: "customer",
                    timestamp: new Date()
                },
                {
                    id: 2,
                    text: "¡Perfecto! Le comento sobre nuestros planes disponibles...",
                    sender: "agent",
                    timestamp: new Date()
                }
            ]
        },
        4: {
            id: 4,
            name: "Soporte técnico - Internet lento",
            time: "8:45 am",
            unread: 3,
            messages: [
                {
                    id: 1,
                    text: "Mi internet está muy lento desde ayer",
                    sender: "customer",
                    timestamp: new Date()
                },
                {
                    id: 2,
                    text: "Entiendo su molestia. Vamos a revisar su conexión",
                    sender: "agent",
                    timestamp: new Date()
                },
                {
                    id: 3,
                    text: "¿Podría reiniciar su módem por favor?",
                    sender: "agent",
                    timestamp: new Date()
                },
                {
                    id: 4,
                    text: "Ya lo reinicié pero sigue igual",
                    sender: "customer",
                    timestamp: new Date()
                }
            ]
        },
        5: {
            id: 5,
            name: "Cancelación de servicio",
            time: "2:20 pm",
            unread: 0,
            messages: [
                {
                    id: 1,
                    text: "Quiero cancelar mi servicio",
                    sender: "customer",
                    timestamp: new Date()
                },
                {
                    id: 2,
                    text: "Lamento escuchar eso. ¿Podría decirme el motivo?",
                    sender: "agent",
                    timestamp: new Date()
                }
            ]
        },
        6: {
            id: 6,
            name: "Cambio de dirección",
            time: "11:30 am",
            unread: 0,
            messages: [
                {
                    id: 1,
                    text: "Necesito cambiar la dirección de mi servicio",
                    sender: "customer",
                    timestamp: new Date()
                }
            ]
        },
        7: {
            id: 7,
            name: "Consulta sobre planes",
            time: "4:15 pm",
            unread: 1,
            messages: [
                {
                    id: 1,
                    text: "¿Tienen planes empresariales?",
                    sender: "customer",
                    timestamp: new Date()
                },
                {
                    id: 2,
                    text: "¡Por supuesto! Tenemos varios planes empresariales",
                    sender: "agent",
                    timestamp: new Date()
                }
            ]
        },
        8: {
            id: 8,
            name: "Reporte de falla en el servicio",
            time: "6:45 pm",
            unread: 2,
            messages: [
                {
                    id: 1,
                    text: "Se cayó completamente mi servicio",
                    sender: "customer",
                    timestamp: new Date()
                }
            ]
        },
        9: {
            id: 9,
            name: "Información sobre promociones",
            time: "3:10 pm",
            unread: 0,
            messages: [
                {
                    id: 1,
                    text: "¿Hay alguna promoción vigente?",
                    sender: "customer",
                    timestamp: new Date()
                },
                {
                    id: 2,
                    text: "Sí, tenemos varias promociones este mes",
                    sender: "agent",
                    timestamp: new Date()
                }
            ]
        }
    });

    const [currentMessage, setCurrentMessage] = useState("");
    const [activeChat, setActiveChat] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [agentIdCard, setAgentIdCard] = useState(currentUser.idCard); // This should come from your auth system
    const messagesEndRef = useRef(null);

   const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [activeChat, chatData]);

    // Cargar chat pendiente al inicializar
    useEffect(() => {
        loadPendingChat();
    }, []);

    const loadPendingChat = async () => {
        try {
            setLoading(true);
            setError(null);
            
            const pendingChat = await realTimeChatService.getFirstPendingMessage();
            
            if (pendingChat) {
                const formattedChat = formatChatForState(pendingChat);
                setChatData(prevData => ({
                    ...prevData,
                    [pendingChat._id]: formattedChat
                }));
                setActiveChat(pendingChat._id);
            }
        } catch (error) {
            console.error('Error loading pending chat:', error);
            setError('Error al cargar chats pendientes');
        } finally {
            setLoading(false);
        }
    };

    const formatChatForState = (chatFromAPI) => {
        return {
            id: chatFromAPI._id,
            name: chatFromAPI.email?.email || "Chat sin email",
            time: new Date(chatFromAPI.timestamp).toLocaleTimeString(),
            status: chatFromAPI.status,
            unread: chatFromAPI.status === 'Pendiente' ? 1 : 0,
            messages: chatFromAPI.messages.map((msg, index) => ({
                id: index + 1,
                text: msg.message,
                sender: msg.idCard === agentIdCard ? 'agent' : 'customer',
                timestamp: new Date(msg.timestamp),
                idCard: msg.idCard
            }))
        };
    };

    const handleSendMessage = async () => {
        if (currentMessage.trim() !== "" && activeChat) {
            try {
                setLoading(true);
                setError(null);

                // Enviar mensaje al backend
                const response = await realTimeChatService.sendAgentMessage(
                    activeChat, 
                    agentIdCard, 
                    currentMessage
                );

                // Actualizar el estado local con el chat actualizado
                const updatedChat = formatChatForState(response.chat);
                setChatData(prevData => ({
                    ...prevData,
                    [activeChat]: updatedChat
                }));

                setCurrentMessage("");
            } catch (error) {
                console.error('Error sending message:', error);
                setError('Error al enviar mensaje');
            } finally {
                setLoading(false);
            }
        }
    };

    const handleChatSelect = async (chatId) => {
        try {
            setLoading(true);
            setError(null);
            
            // Obtener el chat completo con usuarios
            const fullChat = await realTimeChatService.getChatWithUsers(chatId);
            const formattedChat = formatChatForState(fullChat);
            
            setChatData(prevData => ({
                ...prevData,
                [chatId]: {
                    ...formattedChat,
                    unread: 0 // Marcar como leído
                }
            }));
            
            setActiveChat(chatId);
        } catch (error) {
            console.error('Error loading chat:', error);
            setError('Error al cargar el chat');
        } finally {
            setLoading(false);
        }
    };

    const handleFinalizeChat = async () => {
        if (!activeChat) return;

        try {
            setLoading(true);
            setError(null);

            const finalMessage = "Gracias por contactarnos. Su consulta ha sido finalizada.";
            
            await realTimeChatService.finalizeChatWithMessage(
                activeChat,
                agentIdCard,
                finalMessage
            );

            // Actualizar el estado local
            setChatData(prevData => ({
                ...prevData,
                [activeChat]: {
                    ...prevData[activeChat],
                    status: 'Finalizado',
                    messages: [
                        ...prevData[activeChat].messages,
                        {
                            id: prevData[activeChat].messages.length + 1,
                            text: finalMessage,
                            sender: 'agent',
                            timestamp: new Date(),
                            idCard: agentIdCard
                        }
                    ]
                }
            }));

            // Buscar el siguiente chat pendiente
            setTimeout(() => {
                loadPendingChat();
            }, 1000);

        } catch (error) {
            console.error('Error finalizing chat:', error);
            setError('Error al finalizar el chat');
        } finally {
            setLoading(false);
        }
    };

    const currentMessages = activeChat ? chatData[activeChat]?.messages || [] : [];
    const currentChatName = activeChat ? chatData[activeChat]?.name || "Chat" : "Selecciona un chat";
    const currentChatStatus = activeChat ? chatData[activeChat]?.status : null;

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    return (
        <div className="chat-terminal">
            {error && (
                <div className="error-message">
                    {error}
                    <button onClick={() => setError(null)}>
                        ×
                    </button>
                </div>
            )}

            <div className="chat-container">
                <div className="chat-header">
                    <h2>{currentChatName}</h2>
                    {currentChatStatus && (
                        <span className={`status-badge ${currentChatStatus.toLowerCase()}`}>
                            {currentChatStatus}
                        </span>
                    )}
                    {activeChat && currentChatStatus !== 'Finalizado' && (
                        <button 
                            className="finalize-button"
                            onClick={handleFinalizeChat}
                            disabled={loading}
                        >
                            Finalizar Chat
                        </button>
                    )}
                </div>

                <div className="chat-messages">
                    {loading && (
                        <div className="loading-message">
                            Cargando...
                        </div>
                    )}
                    {currentMessages.map((message) => (
                        <div
                            key={message.id}
                            className={`message ${message.sender === 'agent' ? 'message-agent' : 'message-customer'}`}
                        >
                            <div className="message-bubble">
                                {message.text}
                                <div className="message-time">
                                    {message.timestamp.toLocaleTimeString()}
                                </div>
                            </div>
                        </div>
                    ))}
                    <div ref={messagesEndRef} />
                </div>

                <div className="message-input-container">
                    <textarea
                        className="message-input"
                        value={currentMessage}
                        onChange={(e) => setCurrentMessage(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder="Escribe tu respuesta aquí..."
                        rows="3"
                        disabled={loading || currentChatStatus === 'Finalizado'}
                    />
                    <button 
                        className="send-button" 
                        onClick={handleSendMessage}
                        disabled={loading || !currentMessage.trim() || currentChatStatus === 'Finalizado'}
                    >
                        {loading ? 'Enviando...' : 'Enviar'}
                    </button>
                </div>
            </div>

            <div className="pending-chats">
                <div className="pending-header">
                    <h3>Chats</h3>
                    <button 
                        onClick={loadPendingChat}
                        disabled={loading}
                    >
                        Cargar Pendientes
                    </button>
                </div>

                <div className="chat-list">
                    {Object.values(chatData).map((chat) => (
                        <div
                            key={chat.id}
                            className={`chat-item ${activeChat === chat.id ? 'active' : ''}`}
                            onClick={() => handleChatSelect(chat.id)}
                        >
                            <div className="chat-avatar">
                                <div className="avatar-circle">
                                    <span className="avatar-icon">👤</span>
                                </div>
                            </div>

                            <div className="chat-info">
                                <div className="chat-preview">{chat.name}</div>
                                <div className="chat-time">
                                    {chat.status} - {chat.messages.length} mensajes
                                </div>
                            </div>

                            <div className="chat-meta">
                                {chat.unread > 0 && (
                                    <div className="unread-badge">{chat.unread}</div>
                                )}
                                <div className="chat-timestamp">{chat.time}</div>
                            </div>
                        </div>
                    ))}
                </div>

                {Object.keys(chatData).length === 0 && !loading && (
                    <div className="no-chats">
                        <p>No hay chats disponibles</p>
                        <button onClick={loadPendingChat} disabled={loading}>
                            Buscar chats pendientes
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChatTerminal;